// Login problems: the athletes behind the Admin home's queue, on their own page.
// The Logins report (/admin/logins) is everyone's login history; this is only who needs help.
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AdminPage from '../components/AdminShell';
import LoginIssuesPanel from '../components/admin/LoginIssuesPanel';

export default function AdminLoginProblemsPage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user && user.role !== 'admin' && user.role !== 'internal_staff') navigate('/dashboard');
  }, [user, navigate]);

  return (
    <AdminPage active="overview" title="Login problems"
      subtitle="Athletes who failed to sign in during the last 30 days and have not got in since. Newest first.">
      <LoginIssuesPanel />
    </AdminPage>
  );
}
